module.exports = __webpack_public_path__ + "assets/img/roosterplatform-process-left.0a2a2dfd.png";